import React, { useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom-v5-compat'
import PropTypes from 'prop-types'
import { get } from 'utils/lodash'
import AccountActivityAccordion from 'components/customer-details/accordions/AccountActivityAccordion/AccountActivityAccordion'
import { Box, useTheme, useMediaQuery } from '@mui/material'
import TabMainLayout from 'components/customer-details/layout/TabMainLayout'
import { LAYOUT_HEIGHT } from 'components/customer-details/layout/settings'

const ActivityTab = ({ customerDetails = {} }) => {
  const [searchParams] = useSearchParams()
  const theme = useTheme()
  const isTabletorMobile = useMediaQuery(theme.breakpoints.down('lg'))

  const accountId = useMemo(() => get(customerDetails, 'id', ''), [customerDetails])
  const billingAddressId = useMemo(() => {
    return get(customerDetails, 'billingAddress.id')
  }, [customerDetails])

  const tab = (searchParams.get('tab') || '').toLowerCase()
  const isActivityTab = tab === 'activity'

  useEffect(() => {
    if (isActivityTab) {
      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
      document.documentElement.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
      document.documentElement.style.overflow = ''
    }
  }, [isActivityTab])

  return (
    <TabMainLayout>
      <Box
        py={3}
        pr={isTabletorMobile ? 4 : 2}
        pl={4}
        borderRight={isTabletorMobile ? 0 : 1}
        borderColor="divider"
        minWidth="100%"
        maxWidth="100%"
        height={isTabletorMobile ? '100%' : LAYOUT_HEIGHT}
        sx={{
          overflowY: 'auto',
        }}
      >
        <AccountActivityAccordion accountId={accountId} billingAddressId={billingAddressId} />
      </Box>
    </TabMainLayout>
  )
}

ActivityTab.propTypes = {
  customerDetails: PropTypes.object,
}

export default ActivityTab
